import { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import { set, unset } from "lodash/fp";
import { useId } from "@reach/auto-id";
import "styled-components";
import "../../contexts/display-mode-context/display-mode-context.es.js";
import "../../contexts/global-edit-context/global-edit-context.es.js";
import "../../contexts/toast-context/toast-context.es.js";
import "../../utils/is-valid-ref.es.js";
import "../../hooks/use-horizontal-scroll.es.js";
import "react-use-measure";
import "@juggle/resize-observer";
import "@reach/utils";
import "@reach/rect";
import "compute-scroll-into-view";
import { clusteredAvatarsContext } from "./clustered-avatars-context.es.js";
const propTypes = {
  children: PropTypes.node.isRequired,
  subtitle: PropTypes.string,
  title: PropTypes.string.isRequired
};
const defaultProps = {
  subtitle: void 0
};
const ClusteredAvatar = ({ children, subtitle, title }) => {
  const id = useId();
  const setItems = useContext(clusteredAvatarsContext);
  useEffect(() => {
    setItems(set(id, { children, id, subtitle, title }));
    return () => {
      setItems(unset(id));
    };
  }, [children, id, setItems, subtitle, title]);
  return null;
};
ClusteredAvatar.propTypes = propTypes;
ClusteredAvatar.defaultProps = defaultProps;
export {
  ClusteredAvatar
};
